<template>
    <ErrorPage code="204"
               status="No Content"
               message="Screen size is too small."
               href-text="Go to Drivetrain Hub"
               :href="$urls.SITE_HOME"
               :refresh-link="true"
    />
</template>

<script>
  import ErrorPage from "../components/ErrorPage";

  export default {
    name: "ErrorMobile",
    components: {ErrorPage},
  }
</script>

<style scoped>
</style>
